import * as Yup from "yup";

/** Field rules shared by the Add/Edit Candidate and Add/Edit HR dialogs. */
export var FIELD_MAX = {
  email: 254,
  name: 100,
  designation: 50,
  location: 50,
  phone: 10,
};

export var EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export var HR_EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@spanidea\.com$/i;
export var NAME_REGEX = /^[A-Za-z]+( [A-Za-z]+)*$/;
export var DESIGNATION_REGEX = /^[A-Za-z][A-Za-z0-9 .&/()-]*$/;
export var LOCATION_REGEX = /^[A-Za-z]+( [A-Za-z]+)*$/;
export var PHONE_REGEX = /^[6-9][0-9]{9}$/;

/** Typing filters: drop characters a field can never accept. */
export var sanitize = {
  email: function (value) {
    return String(value || "").replace(/\s/g, "").slice(0, FIELD_MAX.email);
  },
  name: function (value) {
    return String(value || "")
      .replace(/[^A-Za-z ]/g, "")
      .replace(/^ +/, "")
      .replace(/ {2,}/g, " ")
      .slice(0, FIELD_MAX.name);
  },
  designation: function (value) {
    return String(value || "")
      .replace(/[^A-Za-z0-9 .&/()-]/g, "")
      .replace(/^[^A-Za-z]+/, "")
      .replace(/ {2,}/g, " ")
      .slice(0, FIELD_MAX.designation);
  },
  location: function (value) {
    return String(value || "")
      .replace(/[^A-Za-z ]/g, "")
      .replace(/^ +/, "")
      .replace(/ {2,}/g, " ")
      .slice(0, FIELD_MAX.location);
  },
  phone: function (value) {
    return String(value || "").replace(/\D/g, "").slice(0, FIELD_MAX.phone);
  },
};

/** Trims and collapses inner spaces before sending to the API. */
export function cleanText(value) {
  return String(value || "").trim().replace(/\s+/g, " ");
}

export var fieldSchema = {
  email: function (label) {
    return Yup.string()
      .trim()
      .required(label + " is required")
      .max(FIELD_MAX.email, label + " cannot exceed " + FIELD_MAX.email + " characters")
      .matches(EMAIL_REGEX, "Enter a valid email address");
  },
  hrEmail: function () {
    return fieldSchema.email("Email").matches(HR_EMAIL_REGEX, "Enter a valid Spanidea email (name@spanidea.com)");
  },
  name: function () {
    return Yup.string()
      .trim()
      .required("Full name is required")
      .min(2, "Full name must be at least 2 characters")
      .max(FIELD_MAX.name, "Full name cannot exceed " + FIELD_MAX.name + " characters")
      .matches(NAME_REGEX, "Full name can contain only letters and spaces");
  },
  designation: function () {
    return Yup.string()
      .trim()
      .required("Designation is required")
      .min(2, "Designation must be at least 2 characters")
      .max(FIELD_MAX.designation, "Designation cannot exceed " + FIELD_MAX.designation + " characters")
      .matches(DESIGNATION_REGEX, "Designation can contain letters, numbers and . & / ( ) -");
  },
  location: function (label) {
    return Yup.string()
      .trim()
      .required(label + " is required")
      .min(2, label + " must be at least 2 characters")
      .max(FIELD_MAX.location, label + " cannot exceed " + FIELD_MAX.location + " characters")
      .matches(LOCATION_REGEX, label + " can contain only letters and spaces");
  },
  phone: function () {
    return Yup.string()
      .required("Phone number is required")
      .length(FIELD_MAX.phone, "Phone number must be 10 digits")
      .matches(PHONE_REGEX, "Phone number must start with 6, 7, 8 or 9");
  },
  select: function (message, options) {
    return Yup.string().required(message).oneOf(options, message);
  },
};
